import { defineMessages } from 'react-intl';

export const ProfileMessages = defineMessages({
  profile: {
    id: 'Profile.profile',
    defaultMessage: 'Profile',
  },
  organization: {
    id: 'Profile.organization',
    defaultMessage: 'Organization',
  },
  role: {
    id: 'Profile.role',
    defaultMessage: 'Role',
  },
  preferences: {
    id: 'Profile.preferences',
    defaultMessage: 'Preferences',
  },
  darkMode: {
    id: 'Profile.darkMode',
    defaultMessage: 'Dark Mode',
  },
  useMetricSystem: {
    id: 'Profile.useMetricSystem',
    defaultMessage: 'Use Metric System',
  },
  language: {
    id: 'Profile.language',
    defaultMessage: 'Language',
  },
  privacyPolicy: {
    id: 'Profile.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  licenseAgreement: {
    id: 'Profile.licenseAgreement',
    defaultMessage: 'StoneAge End User License Agreement',
  },
  support: {
    id: 'Profile.support',
    defaultMessage: 'Support',
  },
  helpCenter: {
    id: 'Profile.helpCenter',
    defaultMessage: 'Help Center',
  },
  trainingResources: {
    id: 'Profile.trainingResources',
    defaultMessage: 'Training Resources',
  },
  sentinelManualOffline: {
    id: 'Profile.sentinelManualOffline',
    defaultMessage: 'Sentinel Manual (Offline)',
    description:
      'Display text for a link to the offline manual for the Sentinel system. Sentinel is a proper noun and should not be translated..',
  },
  provideFeedback: {
    id: 'Profile.provideFeedback',
    defaultMessage: 'Provide Feedback',
  },
  about: {
    id: 'Profile.about',
    defaultMessage: 'About',
  },
  feedbackDescription: {
    id: 'Profile.feedbackDescription',
    defaultMessage:
      'We would love to hear any feedback you have using our Sentinel Link software. Anything from a misspelling, a system crash, long load times, or even something you thought was cool, would be invaluable to our design and development process. We want to make Sentinel Link the best possible experience for you and your customers. Let us know how we can help. Thank you!',
  },
  feedbackSignOff: {
    id: 'Profile.feedbackSignOff',
    defaultMessage: 'StoneAge Software Team',
  },
  followUpOptIn: {
    id: 'Profile.followUpOptIn',
    defaultMessage: 'I am open to a follow up conversation with the StoneAge team.',
  },
  submitFeedback: {
    id: 'Profile.submitFeedback',
    defaultMessage: 'Submit Feedback',
  },
  feedbackPlaceholder: {
    id: 'Profile.feedbackPlaceholder',
    defaultMessage: 'Tell us about your experience',
  },
  feedbackSuccess: {
    id: 'Profile.feedbackSuccess',
    defaultMessage: 'Thanks for your feedback!',
  },
  editProfile: {
    id: 'Profile.editProfile',
    defaultMessage: 'Edit Profile',
  },
  firstName: {
    id: 'Profile.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'Profile.lastName',
    defaultMessage: 'Last Name',
  },
  languageHelperText: {
    id: 'Profile.languageHelperText',
    defaultMessage: 'Language is set in your browser or device settings.',
  },
  stoneAgeUsersLabel: {
    id: 'Profile.stoneAgeUsersLabel',
    defaultMessage: 'StoneAge Users',
  },
  stoneAgeUsersGridEmptyLabel: {
    id: 'Profile.stoneAgeUsersGridEmptyLabel',
    defaultMessage: 'Sorry, no users matched the query.',
  },
  roleRequiredLabel: {
    id: 'Profile.roleRequiredLabel',
    defaultMessage: 'Role is required',
  },
  updateUserRoleHeader: {
    id: 'Profile.updateUserRoleHeader',
    defaultMessage: 'Update User Role',
  },
  setUserRolePlaceholder: {
    id: 'Profile.setUserRole',
    defaultMessage: 'Set the user role',
  },
  userRoleSetSuccessfully: {
    id: 'Profile.userRoleSetSuccessfully',
    defaultMessage: 'User {name} set to role "{role}" successfully!',
    description:
      'Displayed to user after a specific user was set to a new role. {name} and {role} should not be translated.',
  },
  userRoleSetUnsuccessful: {
    id: 'Profile.userRoleSetUnsuccessful',
    defaultMessage: 'Error setting user {name} to role {role}. Please try again later',
    description: 'Displayed when a role set is unsuccesful for a user. {name} and {role} should not be translated.',
  },
  profileNameUpdated: {
    id: 'Profile.profileNameUpdated',
    defaultMessage: 'Profile name updated successfully!',
  },
  deviceAuthorizationLoading: {
    id: 'Profile.deviceAuthorizationLoading',
    defaultMessage: 'Starting authorization...',
  },
  deviceAuthorizationSuccess: {
    id: 'Profile.deviceAuthorizationSuccess',
    defaultMessage: 'Authorized successfully.',
  },
  deviceAuthorizationFailure: {
    id: 'Profile.deviceAuthorizationFailure',
    defaultMessage: 'Unable to authorize. Please try again.',
  },
});
